import { useEffect, useState } from "react";
import {
  MenuItem,
  ListItemText,
  ListItemIcon,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Collapse,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { useGlobalContext } from "../../stores/Global";
import { UserService } from "../../services/api";
import { UpdateUserLanguageLanguageEnum } from "../../services/swagger";

interface LanguageSwitcherProps {
  lang?: "en" | "tr";
}

export default function LanguageSwitcher(props: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation("LanguageSwitcher");
  const { context, setContext } = useGlobalContext();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (context.language !== i18n.language) {
      i18n.changeLanguage(context.language);
    }
  }, [context]);

  const handleToggleMenu = () => {
    setOpen((e) => !e);
  };

  const handleLanguageChange = (lang: string) => {
    setContext({ ...context, language: lang });
    localStorage.setItem("language", lang);
    UserService.updateUserLanguage({
      language: lang as UpdateUserLanguageLanguageEnum,
    });
    setOpen(false);
  };

  const languages = [
    {
      name: "English",
      language: "en",
      icon: (
        <ReactCountryFlag
          svg
          countryCode="GB"
          style={{ height: 20, width: 20 }}
        />
      ),
    },
    {
      name: "Türkçe",
      language: "tr",
      icon: (
        <ReactCountryFlag
          svg
          countryCode="TR"
          style={{ height: 20, width: 20 }}
        />
      ),
    },
  ];

  return (
    <>
      <MenuItem onClick={handleToggleMenu} sx={{ width: 1 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width={1}
          spacing={2}
        >
          <Typography>{t("Language")}</Typography>
          <Stack direction="row" alignItems="center">
            {languages.find((l) => l.language === context.language)?.icon}

            <ArrowDropDownIcon color="disabled" />
          </Stack>
        </Stack>
      </MenuItem>
      <Collapse component={Box} in={open}>
        {languages.map((l) => (
          <MenuItem
            key={l.language}
            onClick={() => handleLanguageChange(l.language)}
          >
            <ListItemIcon>{l.icon}</ListItemIcon>
            <ListItemText>{l.name}</ListItemText>
          </MenuItem>
        ))}
      </Collapse>
    </>
  );
}
